import { useState } from 'react';

const useInput = ({ onChange, name, value }) => {
  const [focused, setFosuced] = useState(false);

  const handleChange = ({ target }) => {
    onChange(name, target.value);
  };

  const handleFocus = (_e: FocusEvent) => {
    setFosuced(true);
  };

  const handleBlur = (_e: FocusEvent) => {
    setFosuced(false);
  };

  const hasValue = !!value || value === 0;

  return { focused, handleBlur, handleChange, handleFocus, hasValue };
};

export default useInput;
